export default __webpack_public_path__ + "static/media/1.baa2181a.webp";